import DecimalConvert from "./DecimalConvert";

export default DecimalConvert;
